export default function getBaseUrl(env) {
  return env === "sandbox" ? process.env["REACT_APP_BACKEND_BASE_URL_DEV"] : process.env["REACT_APP_BACKEND_BASE_URL"];
}
